import { render, staticRenderFns } from "./CommentComponent.vue?vue&type=template&id=f84b5920&scoped=true"
import script from "./CommentComponent.vue?vue&type=script&lang=ts"
export * from "./CommentComponent.vue?vue&type=script&lang=ts"
import style0 from "./CommentComponent.vue?vue&type=style&index=0&id=f84b5920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84b5920",
  null
  
)

export default component.exports